<template>
<div>
    <div
        style="line-height: 55px"
    >
        <span
            v-for="(item, index) in rc_tags"
            :key="index"
        >
            <v-chip
                
                :color="item.color"
                style="margin-right: 5px;"
            >
                {{item.label}}
            </v-chip>

            <span
                v-if="separator == 'includes-any' && index != rc_tags.length - 1"
                style="margin-right: 5px"
            >
                or
            </span>

            <span
                v-if="separator == 'includes-all' && index != rc_tags.length - 1"
                style="margin-right: 5px"
            >
                and
            </span>
        </span>
        
        <span
            v-if="separator != null && rc_tags.length == 0"
        >
            <v-chip>Any</v-chip>
        </span>

        <span
            v-if="show_close"
        >
            <v-icon
                v-on:click="$emit('close')"
            >
                mdi-close-circle
            </v-icon>
        </span>

    </div>
</div>
</template>

<script>
const _ = require('lodash');
export default {

    props: {
        value: {
            type: Array,
            default: function() { return []; }
        },

        separator: {
            type: String,
            default: function() { return null; }
        },

        show_close: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
            rc_tags: []
        }
    },

    mounted () {
        this.updateInternalValue();
    },

    methods: {
        updateInternalValue() {
            let value = _.cloneDeep(this.value);

            if ( value.length == 0 )
            {
                this.rc_tags = [];
                return;
            }

            if ( typeof value[0] !== 'string' )
            {
                this.rc_tags = value;
                return;
            }

            this.$rc.rest(
                'PUT: /api/v1/rc-tags/front-end',
            
                {
                    'rc_tag_ids': value
                },
            
                (data) => {
                    this.rc_tags = data.rc_tags;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to get tag information');
                },
            );
        }
    },

    watch: {
        value(newValue, oldValue) {
            this.updateInternalValue();
        }
    },
}
</script>

<style lang="scss" scoped>

</style>